import {BadgeNomination} from './types/BadgeNomination';
import {BadgeReceived} from './types/BadgeReceived';
import {DocumentCommentAdded} from './types/CommentAdded';
import {GenericNotification} from './types/GenericNotification';
import {DocumentMentionAdded} from './types/MentionAdded';
import {SubscribedOoo} from './types/SubscribedOoo';
import {WorkstreamAccess} from './types/Workstream';
import {WorkstreamReadinessAttention} from './types/WorkstreamReadinessAttention';
import {NotificationCardContext, NotificationProvider} from './utils/useNotificationContext';

// Special notifications, otherwise use the GenericNotification
const NotificationComponentMapping = {
  // Badges require looking up badge data
  badge_received: BadgeReceived,
  badge_nomination: BadgeNomination,

  workstream_access: WorkstreamAccess,
  workstream_readiness_attention: WorkstreamReadinessAttention,

  // document comment thread lookups
  document_comment_added: DocumentCommentAdded,

  document_mention_added: DocumentMentionAdded,

  subscribed_ooo: SubscribedOoo,
};

export const NotificationRenderer = (props: NotificationCardContext) => {
  const NotificationComponent =
    NotificationComponentMapping[
      props.notification.type as keyof typeof NotificationComponentMapping
    ] ?? GenericNotification;

  return (
    <NotificationProvider {...props}>
      <NotificationComponent />
    </NotificationProvider>
  );
};
